<template>
  <div class="goods-detail-imgs-con">
    <van-swipe class="detail-swipe" :autoplay="10000" indicator-color="#999" :width="swipeWidth">
      <van-swipe-item v-for="(item, i) in imgs" :key="i" @click="lookPic(i)">
        <img class="detail-swipe-img" :src="'http://img13.360buyimg.com/n12/' + item.path" alt="">
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  porps: {

  },
  components:{
  },
  computed:{
    ...mapGetters([
      'currentSku',//当前sku
      'skusImgs',//所有sku的所有图片
    ])
  },
  watch: {
    currentSku(sku){
      this.imgs = this.skusImgs[sku]
    },
    skusImgs(){
      this.imgs = this.skusImgs[this.currentSku]
    },
  },
  data(){
    return {
      swipeWidth: window.screen.width || 375,
      swipeHeight: window.screen.width || 375,
      imgs: [],
    }
  },
  created(){
    console.log(this.skusImgs)
  },
  methods: {
    //查看大图
    lookPic(i){
      this.$store.commit('sg/pictureLook', i)
    },
  }
}
</script>

<style lang="less" scoped>
.goods-detail-imgs-con{
  position: absolute;z-index: 1;width: 100%;height: 375px;
  padding: 0 0;
  .detail-swipe{
    border-radius: 5px;
    z-index: 10;
    width: 375px;
    height: 375px;
    .detail-swipe-img{
      width: 100%;height: 100%;
    }
  }
}
</style>